module.exports = __webpack_public_path__ + "static/coat-of-arms-dc0b8e5ebb3dd02ab1c1c9c8040faa0b.png";